export const environment = {
	production: true,
	hmr       : false,
	serverAddress: '',
	serverPort: 80,
	apiRoutePrefix: '/booking_engine',
	sessionMaxAge: 24 * 60 * 60,
	websocket: {
		enabled: false,
		port: 3444,
		// url: 'http://localhost' //default use same of serverAddress
	}
};
